import React, { useState, useRef, useEffect } from 'react'
import './styles/ChatBot.css'
import { API_URLS } from '../../config'; // Import API_URLS

export default function ChatBot() {
  const token = localStorage.getItem('token');
  const businessId = localStorage.getItem('businessId'); // Get businessId from localStorage
  const [messages, setMessages] = useState([])
  const [input, setInput] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const messagesEndRef = useRef(null)
  const isInitialMount = useRef(true) // Added ref to track initial mount

  const scrollToBottom = () => {
    if (messages.length <= 0) return
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      return // Prevent scrolling on initial mount
    }
    scrollToBottom()
  }, [messages])

  const handleInputChange = (e) => {
    setInput(e.target.value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (input.trim() === '') return

    const newUserMessage = { role: 'user', content: input }
    setMessages((prevMessages) => [...prevMessages, newUserMessage])
    setInput('')
    setIsLoading(true)
    try {
      const user = JSON.parse(localStorage.getItem('user')) || {}; // Add fallback for user
      const userId = user.userId || 'anonymous_dashboard_user'; // Provide a default userId if not logged in or user data is missing
      const response = await fetch(API_URLS.chatbot(businessId), { // Correctly call the chatbot function
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Include the token in the Authorization header
      },
      body: JSON.stringify({
        message: input,
        userId: userId // Ensure userId is always sent
       })
      })
      const data = await response.json()
      if (!response.ok) {
      
      setMessages((prevMessages) => [...prevMessages, { role: 'ai', content: 'There was an unexpected error, try again!' }])
      } else {
        // Ensure data.answer exists and is a string, or provide a fallback.
        const aiResponseContent = data && typeof data.answer === 'string' ? data.answer : 'Sorry, I could not understand that.';
        setMessages((prevMessages) => [...prevMessages, { role: 'ai', content: aiResponseContent }])
      }
       
    } catch (error) {
      console.error('Error fetching AI response:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="glass-box chat-wrapper">
      <div className="chat-container">
        {messages.map((message, i) => (
          <div
            key={i}
            className={`message ${message.role === 'user' ? 'user-message' : 'ai-message'}`}
          >
            <span className="message-content">
              {message.content}
            </span>
          </div>
        ))}
        {isLoading && (
          <div className="loading-indicator">AI is thinking...</div>
        )}
        <div ref={messagesEndRef} />
      </div>
      <form onSubmit={handleSubmit} className="input-form">
        <input
          type="text"
          value={input}
          onChange={handleInputChange}
          placeholder="Type your message..."
          className="chat-input"
        />
        <button
          type="submit"
          disabled={isLoading}
          className="send-button"
        >
          Send
        </button>
      </form>
    </div>
  )
}